/*------------------------------------------------------------------------------------------
* © 2020 KPMG LLP, a Delaware limited liability partnership and 
* a member firm of the KPMG global organization of independent member firms 
* affiliated with KPMG International Limited, a private English company limited by guarantee. 
* All rights reserved.
*-----------------------------------------------------------------------------------------*/
import { Component, OnInit, Renderer2 } from '@angular/core';
import { ProgressIndicatorService } from './progress-indicator.service';

@Component({
  selector: 'app-progress-indicator',
  templateUrl: './progress-indicator.component.html',
  styleUrls: ['./progress-indicator.component.css']
})
export class ProgressIndicatorComponent implements OnInit {
  isActive: boolean;

  constructor(private _progressService: ProgressIndicatorService,private renderer: Renderer2) { }

  ngOnInit() {

    this._progressService.isloaderactive$.subscribe({

      next: (result: any) => {   
        if(result){
          this.renderer.addClass(document.body, 'hide-overflow');
          this.renderer.addClass(document.body.parentElement, 'hide-overflow');
        }else{
          this.renderer.removeClass(document.body, 'hide-overflow');
          this.renderer.removeClass(document.body.parentElement, 'hide-overflow');
        }     
        this.isActive = result;
       
      }
      // ,
      // error: (err: any) => {
      //   console.log(err);
      // }
    });

  }
}
